import React from "react";
import { PageTopProps } from "./PageTopProps.d";
import { formatDate } from '../../../react4xp/components/DateComponent';


export function PageTop(props: Readonly<PageTopProps>): React.JSX.Element {
	const {
		title,
		ingress,
		image,
		imageText,
		variant,
		published,
		modified,
	} = props;

	return variant === "info" ? (
		<section className="pt-lg tablet:pt-xl pb-xl tablet:pb-xxl">
			<div className="flex flex-col gap-lg">
				<div className="flex flex-wrap gap-sm items-center">
					{image &&
						<img className="h-20 w-20 self-center" src={image.url} alt={image.alt} />
					}
					{title &&
						<h1 className="text-[36px] font-bold text-balance">{title}</h1>
					}
				</div>
				<p className="text-xl max-w-text">{ingress}</p>
				{published && (
					<div className="flex flex-wrap text-[#504F4F]">
						<p className="flex-shrink-0">Publisert: {formatDate(published)}</p>
						<span className="mx-xs">|</span>
						<p className="flex-shrink-0">Oppdatert: {formatDate(modified)}</p>
					</div>
				)}
			</div>
		</section>
	) : (
		<section className="pt-lg tablet:pt-xl pb-xl tablet:pb-xxl">
			<div className="flex flex-col gap-lg">
				{title &&
					<h1 className="text-[36px] font-bold text-balance">{title}</h1>
				}
				<p className="text-xl max-w-text">{ingress}</p>
				{published && (
					<div className="flex flex-wrap text-[#504F4F]">
						<p className="flex-shrink-0">Publisert: {formatDate(published)}</p>
						<span className="mx-xs">|</span>
						<p className="flex-shrink-0">Oppdatert: {formatDate(modified)}</p>
					</div>
				)}
				{image &&
					<figure>
						<img className="mb-xs h-auto tablet:h-[560px] w-auto" src={image.url} alt={image.alt} />
						{imageText || image.caption &&
							<figcaption className="text-sm">
								{imageText ? imageText : image.caption}
							</figcaption>
						}
					</figure>
				}
			</div>
		</section>
	);
}
